<template>
  <section />
</template>
<script>
export default {
    name: 'Cookie',
  methods: {
      setCookie(cname, value, expiry) {
          const d = new Date();
          d.setTime(d.getTime() + (expiry*24*60*60*1000));
          let expires = "expires="+ d.toUTCString();
          document.cookie = cname + "=" + value + ";" + expires + ";path=/";
      },
      getCookie(cname) {
          let name = cname + "=";
          let decodedCookie = decodeURIComponent(document.cookie);
          let ca = decodedCookie.split(';');
          for(let i = 0; i <ca.length; i++) {
              let c = ca[i];
              while (c.charAt(0) == ' ') {
                  c = c.substring(1);
              }
              if (c.indexOf(name) == 0) {
                  return c.substring(name.length, c.length);
              }
          }
          return "";
      },
      deleteCookie(cname) {
          document.cookie = cname+'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      }
  }
};
</script>
